{
  "open": "Administration",
  "backProfile": "Retour au profil",
  "backList": "Retour à la liste",
  "saved": "Modification enregistrée",
  "saveFailed": "Enregistrement impossible",
  "catalogCreated": "Entrée du catalogue créée",
  "createFailed": "Création impossible",
  "catalogDeleted": "Entrée du catalogue supprimée",
  "deleteFailed": "Suppression impossible",
  "deleteAnime": "Supprimer l’œuvre",
  "deleteCharacter": "Supprimer le personnage",
  "confirmDeleteAnime": "Supprimer définitivement « {{name}} » et tous ses personnages, cartes possédées, annonces, enchères, échanges et complétions ? Cette action est irréversible.",
  "confirmDeleteCharacter": "Supprimer définitivement « {{name}} », y compris les cartes possédées, annonces, enchères, échanges et références de profil ? Cette action est irréversible.",
  "addAnime": "Ajouter une œuvre",
  "addCharacter": "Ajouter un personnage à cette série",
  "animeTitle": "Titre",
  "animeType": "Type d’œuvre",
  "animeTypeAnime": "Anime",
  "animeTypeManga": "Manga",
  "animeTypeNovel": "Roman",
  "animeTypeVideoGame": "Jeux vidéo",
  "animeTypeCinematography": "Cinématographie",
  "coverImageUrl": "URL de l’image de couverture",
  "bannerImageUrl": "URL de la bannière",
  "characterName": "Nom du personnage",
  "characterImageUrl": "URL de l’image du personnage",
  "allowedImageHosts": "Hôtes autorisés : s4.anilist.co, zupimages.net, ou la bibliothèque d’images ANIDEX.",
  "rarity": "Rareté",
  "role": "Rôle",
  "rarities": {
    "common": "Commun",
    "uncommon": "Peu commun",
    "rare": "Rare",
    "epic": "Épique",
    "legendary": "Légendaire",
    "mythic": "Mythique",
    "divine": "Divin",
    "senita": "Senita"
  },
  "requested": "Demande envoyée",
  "requestFailed": "Demande impossible",
  "approved": "Permission accordée",
  "denied": "Demande refusée",
  "revoked": "Permission retirée",
  "nav": {
    "label": "Administration",
    "board": "Tableau",
    "anime": "Œuvres",
    "characters": "Personnages",
    "players": "Joueurs",
    "roles": "Rôles",
    "requests": "Demandes",
    "reports": "Signalements",
    "content": "Contenu",
    "animations": "Animations",
    "missingImages": "Images manquantes"
  },
  "contentPage": {
    "title": "Contenu",
    "overview": "Vue d’ensemble",
    "titles": "Titres",
    "badges": "Badges",
    "frames": "Cadres",
    "avatars": "Avatars",
    "banners": "Bannières",
    "achievements": "Succès",
    "quests": "Quêtes",
    "search": "Rechercher",
    "tier": "Palier",
    "allTiers": "Tous les paliers",
    "owners_one": "{{count}} possède",
    "owners_other": "{{count}} possèdent",
    "worn_one": "{{count}} porte",
    "worn_other": "{{count}} portent",
    "unlockedBy_one": "{{count}} joueur",
    "unlockedBy_other": "{{count}} joueurs",
    "reached_one": "{{count}} déjà obtenu par au moins un joueur",
    "reached_other": "{{count}} déjà obtenus par au moins un joueur",
    "rewardOptions_one": "{{count}} récompense possible",
    "rewardOptions_other": "{{count}} récompenses possibles",
    "coverage": "Couverture",
    "coverageOk": "Chaque cosmétique est donné par un palier de succès.",
    "objectives": "Objectifs",
    "effort": "effort {{effort}}",
    "from": "Donné par",
    "daily": "Quotidien",
    "weekly": "Hebdomadaire",
    "monthly": "Mensuel",
    "animate": "Animé",
    "static": "Statique",
    "preview": "Cabine d’essayage",
    "weight": "Poids {{weight}}",
    "rewards": "Récompenses possibles",
    "cosmeticTracks_one": "{{count}} succès donne un cosmétique tous les {{step}} paliers",
    "cosmeticTracks_other": "{{count}} succès donnent un cosmétique tous les {{step}} paliers",
    "tierTargets": "Paliers 1, 2, 3, 5, 10 : {{targets}}",
    "maxTier": "Palier max : {{tier}}"
  },
  "range": {
    "label": "Période",
    "days": "{{count}} jours"
  },
  "premium": {
    "title": "Premium",
    "activeUntil": "Actif jusqu'au {{until}}",
    "inactive": "Aucun Premium actif.",
    "duration": "Durée du Premium (jours)",
    "grant": "Accorder le Premium",
    "granted": "Premium accordé",
    "logs": "Logs de Premium",
    "noLogs": "Aucun Premium accordé manuellement.",
    "sourceFree": "Gratuit",
    "logLine": "{{days}} jours · jusqu'au {{until}} · par {{by}}"
  },
  "players": {
    "intro": "Recherche un joueur pour consulter son économie, son Premium, ses rôles et ses permissions.",
    "caption": "Liste des joueurs",
    "empty": "Aucun joueur trouvé.",
    "never": "Jamais",
    "columns": {
      "player": "Joueur",
      "level": "Niveau",
      "anima": "Anima",
      "cards": "Cartes",
      "status": "Statut",
      "lastLogin": "Dernière connexion"
    },
    "status": {
      "active": "Actif",
      "blocked": "Bloqué"
    }
  },
  "player": {
    "tabsLabel": "Sections du joueur",
    "tabs": {
      "account": "Compte",
      "premium": "Premium",
      "economy": "Économie",
      "roles": "Rôles",
      "permissions": "Permissions",
      "data": "Données"
    },
    "info": "Informations",
    "actions": "Actions",
    "level": "Niveau",
    "anima": "Anima",
    "cards": "Cartes",
    "email": "Email",
    "verification": "Email vérifié",
    "status": "Statut",
    "owner": "Propriétaire"
  },
  "data": {
    "edit": "Modifier les données",
    "username": "Pseudo",
    "anima": "Solde d’Anima",
    "xp": "EXP",
    "save": "Enregistrer",
    "saved": "Données enregistrées",
    "nothingToSave": "Rien à enregistrer",
    "reset": "Réinitialiser",
    "resetHint": "Choisis ce que tu veux remettre à zéro. La réinitialisation complète remet le compte à l’état de nouveau joueur, tout en conservant l’identité et le Premium.",
    "resetScopes": {
      "achievements": {
        "label": "Succès",
        "confirm": "Effacer tous les succès de ce joueur ?",
        "done": "Succès réinitialisés"
      },
      "collection": {
        "label": "Collection",
        "confirm": "Vider la collection (cartes et fragments) de ce joueur ?",
        "done": "Collection réinitialisée"
      },
      "level": {
        "label": "Niveau",
        "confirm": "Remettre le niveau et l’EXP à zéro ?",
        "done": "Niveau réinitialisé"
      },
      "anima": {
        "label": "Anima",
        "confirm": "Remettre le solde d’Anima à zéro ?",
        "done": "Anima réinitialisés"
      },
      "all": {
        "label": "Toutes les données",
        "confirm": "Réinitialiser TOUTES les données de jeu de ce joueur ? Cette action est irréversible.",
        "done": "Données réinitialisées"
      }
    }
  },
  "playerEconomy": {
    "title": "Anima et récompenses",
    "allTime": "Tout l’historique",
    "currentBalance": "Solde actuel",
    "received": "Entrées d’Anima",
    "spent": "Sorties d’Anima",
    "net": "Variation sur la période",
    "flow": "Anima reçus et sortis",
    "flowHint": "Les flux incluent les séquestres et leurs remboursements, qui ne sont pas de nouvelles récompenses.",
    "sources": "D’où viennent les Anima ?",
    "sourcesHint": "Montants reçus, répartis par origine.",
    "daily": "Totaux par jour, en UTC.",
    "monthly": "Totaux par mois, en UTC.",
    "chartData": "Voir les montants du graphique",
    "period": "Période",
    "history": "Historique du joueur",
    "ledger": "Journal d’Anima",
    "rewards": "Récompenses",
    "refresh": "Actualiser les historiques",
    "source": "Origine",
    "allSources": "Toutes les origines",
    "date": "Date (UTC)",
    "amount": "Mouvement",
    "balanceAfter": "Solde après",
    "direction": "Sens du mouvement",
    "directions": {
      "all": "Tous",
      "in": "Entrées",
      "out": "Sorties"
    },
    "reference": "Référence",
    "rewardReference": "Détails du versement",
    "ledgerHint": "Chaque mouvement indique son origine et le solde juste après. Les filtres du journal ne changent pas les graphiques.",
    "rewardsHint": "Récompenses réellement reçues : Anima, EXP, boosters, cartes, fragments et cosmétiques. Les valeurs sont celles du versement.",
    "noMovements": "Aucun mouvement à afficher.",
    "noIncome": "Aucune entrée d’Anima sur cette période.",
    "noRewards": "Aucune récompense avec ces filtres.",
    "emptyHint": "Change la période ou les filtres pour chercher d’autres événements.",
    "loaded": "{{loaded}} sur {{total}} événements affichés",
    "level": "Niveau {{level}}",
    "sponsor": "Parrain : {{name}}",
    "characterId": "Personnage #{{id}}",
    "duplicate": "Doublon converti en {{amount}} fragments pour {{name}}.",
    "cardGranted": "Carte reçue : {{name}}.",
    "ledgerTypes": {
      "signup_bonus": "Bonus d’inscription",
      "booster_purchase": "Achat de boosters",
      "quest_reward": "Récompense de quête",
      "achievement_reward": "Récompense de succès",
      "level_reward": "Récompense de niveau",
      "login_reward": "Récompense du calendrier",
      "admin_adjustment": "Ajustement administratif",
      "market_purchase": "Achat de cartes",
      "market_sale": "Vente de cartes",
      "system_sale": "Reprise par le système",
      "auction_hold": "Séquestre d’enchère",
      "auction_refund": "Remboursement d’enchère",
      "trade_hold": "Séquestre d’échange",
      "trade_release": "Libération d’échange",
      "trade_payment": "Paiement d’échange",
      "trade_received": "Anima reçus par échange",
      "fragment_conversion": "Conversion de fragments",
      "anime_completion": "Série complétée",
      "harvest_payout": "Moisson d’Anima",
      "referral_bonus": "Bonus de parrainage"
    },
    "rewardTypes": {
      "signup": "Bonus d’inscription",
      "quest": "Quête",
      "achievement": "Succès",
      "level": "Niveau",
      "login": "Calendrier",
      "anime": "Série complétée",
      "referral": "Parrainage",
      "harvest": "Moisson"
    }
  },
  "metrics": {
    "circulation": "Anima en circulation",
    "circulationHint": "Somme des soldes des comptes encore ouverts.",
    "spend": "Dépenses des joueurs",
    "spendHint": "Boosters achetés et achats au marché. Les mises en séquestre ne comptent pas.",
    "boosters": "Boosters",
    "market": "Marché",
    "harvest": "Cagnotte de la moisson",
    "harvestHint": "Le pot du mois ouvert, et ce qui y est entré chaque jour.",
    "harvestAdded": "{{amount}} ajoutés sur la période",
    "month": "Mois {{month}}",
    "noMonth": "Aucune moisson ouverte",
    "daily": "Jour par jour",
    "emptyChart": "Pas encore de mouvement sur cette période."
  },
  "search": "Rechercher",
  "searchAnime": "Titre",
  "searchCharacter": "Nom",
  "searchPlayer": "Pseudo ou email",
  "more": "Afficher la suite",
  "charactersCount": "{{count}} personnages",
  "pickAnime": "Choisis une œuvre pour afficher son casting.",
  "castEmpty": "Cette œuvre n’a aucun personnage.",
  "pickField": "Choisis une œuvre ou un personnage pour ouvrir sa fiche.",
  "inspector": "Fiche",
  "save": "Enregistrer",
  "request": "Demander la permission",
  "pending": "En attente",
  "yes": "Oui",
  "no": "Non",
  "revoke": "Révoquer",
  "block": "Bloquer",
  "unblock": "Débloquer",
  "blocked": "Joueur bloqué",
  "unblocked": "Joueur débloqué",
  "add": "Ajouter",
  "remove": "Retirer",
  "create": "Créer le rôle",
  "rename": "Renommer",
  "deleteRole": "Supprimer le rôle",
  "roleName": "Nom du rôle",
  "username": "Pseudo",
  "animeId": "Identifiant de l’œuvre",
  "members": "Joueurs",
  "assigned": "Œuvres attribuées",
  "noMembers": "Aucun joueur sur ce rôle.",
  "noAnime": "Aucune œuvre attribuée.",
  "grants": "Permissions accordées",
  "noGrants": "Aucune permission particulière.",
  "rolesOf": "Rôles",
  "noRoles": "Aucun rôle.",
  "status": "Statut",
  "level": "Niveau {{level}}",
  "lastLogin": "Dernière connexion",
  "never": "Jamais",
  "verified": "Email vérifié",
  "unverified": "Email non vérifié",
  "owner": "Propriétaire",
  "requestFrom": "{{who}} demande à modifier {{field}}",
  "onEntity": "sur {{name}}",
  "fields": {
    "id": "Identifiant",
    "title": "Nom",
    "title_english": "Nom anglais",
    "title_native": "Nom original",
    "cover_url": "Image",
    "cover_medium_url": "Image moyenne",
    "banner_url": "Bannière",
    "favourites": "Favoris",
    "type": "Type",
    "format": "Format",
    "status": "Statut",
    "season_year": "Année",
    "cover_color": "Couleur",
    "popularity": "Popularité",
    "is_adult": "Public adulte",
    "rank": "Rang",
    "character_count": "Personnages obtenables",
    "synced_at": "Dernière synchro",
    "created_at": "Créé le",
    "name": "Nom",
    "name_native": "Nom original",
    "image_url": "Image",
    "image_medium_url": "Image moyenne",
    "role": "Rôle dans l’œuvre",
    "rarity": "Rareté",
    "value": "Valeur",
    "is_obtainable": "Obtenable",
    "anime_id": "Œuvre liée",
    "__delete": "la suppression"
  },
  "banIp": "Bannir l’IP",
  "banIpReason": "Bannissement d’adresse",
  "ipBanned": "Adresse bannie",
  "ips": "Adresses",
  "reports": {
    "filter": "État des signalements",
    "messageSnapshot": "Contenu au moment du signalement",
    "deletedMessage": "Message supprimé",
    "nickname": "Surnom : {{text}}",
    "signature": "Signature : {{text}}",
    "empty": "Aucun signalement dans cette liste.",
    "ban": "Bannir",
    "banIp": "Bannir l’IP",
    "dismiss": "Classer",
    "status": {
      "open": "Ouverts",
      "resolved": "Traités",
      "dismissed": "Classés"
    },
    "reason": {
      "spam": "Spam",
      "harassment": "Harcèlement",
      "inappropriate": "Contenu inapproprié",
      "impersonation": "Usurpation",
      "other": "Autre"
    },
    "done": {
      "ban": "Joueur banni",
      "ban_ip": "Adresse bannie",
      "dismiss": "Signalement classé"
    }
  },
  "adultYes": "Oui",
  "adultNo": "Non",
  "obtainableYes": "Oui",
  "obtainableNo": "Non",
  "none": "Aucun",
  "missingImages": {
    "title": "Images manquantes",
    "lead": "",
    "totals_one": "{{count}} personnage à compléter",
    "totals_other": "{{count}} personnages à compléter",
    "rankingTitle": "Classement des contributeurs",
    "rankingLead": "",
    "rankingEmpty": "Aucun contributeur pour le moment.",
    "rankingCount_one": "{{formatted}} image",
    "rankingCount_other": "{{formatted}} images",
    "search": "Rechercher un personnage ou une œuvre",
    "cover": "Couverture",
    "banner": "Bannière",
    "applied": "Image appliquée : {{name}}",
    "empty": "Plus aucune image manquante ici 🎉",
    "done": "Image OK",
    "none": "Aucune image",
    "works_one": "{{count}} œuvre sans couverture ou bannière",
    "works_other": "{{count}} œuvres sans couverture ou bannière",
    "workTotals": "{{count}} / {{total}} personnages sans image",
    "workImages": "Images de l’œuvre",
    "noCharacters": "Aucun personnage dans cette œuvre.",
    "deleteRequest": "Demander la suppression",
    "deletePending": "Suppression demandée",
    "deleteRequested": "Demande de suppression envoyée : {{name}}",
    "confirmDeleteCharacter": "Envoyer une demande de suppression pour « {{name}} » ? Un owner devra la valider dans Demandes.",
    "confirmDeleteAnime": "Envoyer une demande de suppression pour l’œuvre « {{name}} » et tout son casting ? Un owner devra la valider dans Demandes.",
    "statusLabel": "Filtrer par état de l’image",
    "status": {
      "missing": "Sans image",
      "done": "Avec image",
      "all": "Tous"
    },
    "emptyDone": "Aucun personnage avec image ici.",
    "rarity": "Rareté de {{name}}",
    "rarityChanged": "{{name}} : {{rarity}} (valeur {{value}})"
  },
  "webSuggestions": {
    "toggle": "Suggestions web",
    "lead": "Clique sur une proposition pour la télécharger.",
    "query": "Recherche",
    "search": "Chercher",
    "loading": "Recherche…",
    "empty": "Aucune image trouvée.",
    "emptyFormat_one": "Aucune image au bon format ({{count}} écartée).",
    "emptyFormat_other": "Aucune image au bon format ({{count}} écartées).",
    "showAll_one": "Voir aussi {{count}} image hors format",
    "showAll_other": "Voir aussi {{count}} images hors format",
    "hideOff": "Masquer les images hors format",
    "offFormat": "Hors format",
    "pick": "Utiliser cette image ({{width}} × {{height}})",
    "importing": "Import…",
    "license": {
      "check": "Vérifier les licences",
      "checking": "Vérification…",
      "free": "Libre",
      "restricted": "Non libre",
      "freeHint": "Licence Creative Commons autorisant l’usage commercial et la modification, d’après Google. Vérifie la licence et l’attribution demandée sur la page source.",
      "restrictedHint": "Aucune licence libre détectée : droits réservés probables (studio, éditeur ou artiste). À n’utiliser qu’avec autorisation."
    },
    "unavailable": "La recherche Google ne répond pas. Réessaie plus tard.",
    "nothingMissing": "Aucune image manquante sur cette page.",
    "format": {
      "image": "Carte · portrait",
      "cover": "Couverture · portrait",
      "banner": "Bannière · paysage"
    }
  },
  "media": {
    "url": "Adresse de l’image",
    "title": "Bibliothèque d’images",
    "hint": "Choisis une image déjà enregistrée ou envoie-en une nouvelle (PNG, JPEG, WebP, GIF, AVIF).",
    "library": "Ouvrir la bibliothèque d’images",
    "upload": "Envoyer une image",
    "uploading": "Envoi…",
    "uploaded": "Image enregistrée",
    "uploadFailed": "Envoi impossible",
    "dropHint": "ou glisse une image ici",
    "dropUnsupported": "Dépose un fichier image (PNG, JPEG, WebP, GIF, AVIF) ou une image d’une page web.",
    "empty": "Aucune image enregistrée pour l’instant.",
    "unnamed": "Sans nom"
  },
  "animations": {
    "title": "Animations",
    "lead": "Rejoue la révélation d’un booster exactement comme un tirage, sans rien dépenser ni rien obtenir.",
    "play": "Jouer l’animation",
    "rarity": "Rareté tirée",
    "cardLevel": "Niveau de la carte",
    "level": "Niveau {{level}}",
    "options": "Mise en scène",
    "booster": "Booster",
    "boosters": {
      "free": "Booster gratuit",
      "standard": "Booster standard",
      "premium": "Booster premium",
      "legendary": "Booster légendaire"
    },
    "fullPack": "Pack complet (5 cartes, la rareté choisie en dernier)",
    "duplicate": "Doublon (fragments au lieu d’une nouvelle carte)",
    "pity": "Garantie de pity",
    "character": "Personnage",
    "sampleName": "Personnage test",
    "sampleHint": "Par défaut, la carte utilise ton avatar. Cherche un personnage pour utiliser son image.",
    "using": "Carte jouée avec {{name}}.",
    "reset": "Retirer"
  },
  "deleteRequestCharacter": "{{who}} demande la suppression du personnage {{name}}",
  "deleteRequestAnime": "{{who}} demande la suppression de l’œuvre {{name}} (et de tout son casting)",
  "deleteRequestWarning": "Accepter supprime définitivement la fiche et rembourse les joueurs qui la possèdent.",
  "deleteRequestApprove": "Supprimer",
  "deleteRequestConfirm": "Supprimer définitivement « {{name}} » ?",
  "deleteRequestDone": "Fiche supprimée"
}
